import { useMutation } from '@tanstack/react-query';
import { markProgramAsSelected } from '../queries/course';

function useMarkProgramAsSelected() {
  const { data, isError, error, isSuccess, isPending, mutate, mutateAsync } = useMutation({
    mutationKey: ['mark-program-as-selected'],
    mutationFn: (data: any) =>
      markProgramAsSelected(data.courseId, data.programId),
    retry: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    mutate,
    mutateAsync
  };
}

export { useMarkProgramAsSelected };
